import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { AlertService } from '../../alert.service';
import { Router } from '@angular/router';
import { ThemeService } from '../../theme.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
  public model: any;
  public secondStage = false;

  constructor(private apiService: ApiService, private alerts: AlertService, private router: Router, public themeSvc: ThemeService) {
    this.model = { username: "", code: "", password1: "", password2: "" };
  }

  get loading() {
    return this.apiService.isLoading;
  }

  handleSubmit() {
    let req = this.apiService.sendPasswordReset(this.model.username);
    req.successFunc = x => {
      if (x.success) {
        this.alerts.alert("If the username you entered is valid, you should receive a code in your email soon.");
        this.secondStage = true;
      } else {
        this.alerts.alert(x.error);
      }
    };
    req.start();
  }

  handleCodeSubmit() {
    if (this.model.password1 !== this.model.password2) {
      return;
    }

    let req = this.apiService.resetPassword(this.model.code, this.model.password1);
    req.successFunc = x => {
      if (x.success) {
        this.router.navigate(['']);
      } else {
        let message = "Please address the following problems:\n" +  x.problems.join("\n");
        this.alerts.alert(message);
      }
    };
    req.start();

  }

  ngOnInit() {
  }

}
